import { useQuery } from "@apollo/client";
import { creditTransactionsQuery } from "../apollo-client/queries";
import { CreditTransaction } from "../apollo-client/types";
import { IonIcon, IonLoading, isPlatform } from "@ionic/react";
import { getLocalizedTransactionType, getPrice } from "../utils";
import { useTenant } from "../hooks/multiTenancy";
import { intlFormat } from "date-fns";
import { useTranslation } from "react-i18next";
import { chevronForwardOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import "./creditTransactions.css";

type ModalProps = {
  fidelitySalesPointId: number;
  idFidelityPrepaidAccount: number;
}

const CreditTransactions: React.FC<ModalProps> = ({ fidelitySalesPointId, idFidelityPrepaidAccount }) => {
  const { t, i18n } = useTranslation();
  const tenant = useTenant();
  const history = useHistory();
  const { loading, data } = useQuery<{ creditTransactions: { records: CreditTransaction[] } }>(creditTransactionsQuery, {
    variables: {
      filter: encodeURIComponent(JSON.stringify({ idFidelityPrepaidAccount: [idFidelityPrepaidAccount] })),
      sorts: encodeURIComponent(JSON.stringify({ date: -1 })),
      start: 0,
      limit: 4,
    },
  });
  return <>
    <IonLoading isOpen={loading} showBackdrop={false} cssClass="infinite-scroll-loader" spinner={isPlatform("ios") ? "lines" : "circular"} />
    { data && data.creditTransactions.records.slice(0, 3).map((c) =>
      <div key={c.id} className="section section-horizontal">
        <div className="transaction-date">
          {intlFormat(c.date * 1000, { year: "2-digit", month: "2-digit", day: "numeric" }, { locale: i18n.language })}
        </div>
        <div className="transaction-type">{t(getLocalizedTransactionType(c.fidelityPrepaidTransactionType))}</div>
        <div className="transaction-amount">{getPrice(c.amount, tenant.settings?.fidelityAccount?.account.currency)}</div>
      </div>
    )}
    {data && data.creditTransactions.records.length > 3 && (
      <div className="section section-horizontal more-section" onClick={() => history.push(`/app/others/myCredit/salesPoint/${fidelitySalesPointId}`)}>
        <div className="more">{t("myCredit.more")}</div>
        <IonIcon icon={chevronForwardOutline} />
      </div>
    )}
  </>;
};

export default CreditTransactions;
